module.exports = __webpack_public_path__ + "static/media/fbjumo.a4d82a85.pdf";